import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import ExpertMentorItem from './ExpertMentorItem'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHRExpertMentors } from '../../../../hooks/useHRExpertMentors'
import { useEffect } from 'react'
import { MentorsDTO } from '../../../../apis/api-assignation'
import { IconName } from '@fortawesome/fontawesome-svg-core'

const HelpRequestPanel = () => {
    const { t } = useTranslation('sidebar')
    const { mentors, isPending, isError, refetch } = useHRExpertMentors()

    // Refetch on mount
    useEffect(() => {
        refetch()
    }, [refetch])

    if (isPending || isError)
        return (
            <HelpRequestPanelStyled>
                <LoadingMessage>{t(isPending ? 'common.loading' : 'common.error')}</LoadingMessage>
            </HelpRequestPanelStyled>
        )

    return (
        <HelpRequestPanelStyled>
            <div className="top">
                <Section mentors={mentors?.availables} title={t('help.available', 'Available')} icon="check-circle" />
                <Section mentors={mentors?.busy} title={t('help.busy', 'Busy')} icon="clock" />
                <Section mentors={mentors?.unavailable} title={t('help.disconnected', 'Disconnected')} icon="ban" />
            </div>
        </HelpRequestPanelStyled>
    )
}

const Section = ({ mentors, title, icon }: { mentors?: MentorsDTO[]; title: string; icon: IconName }) => {
    const { t } = useTranslation('sidebar')

    return (
        <SectionStyles>
            <h3>
                <FontAwesomeIcon icon={['far', icon]} className="section-icon" />
                {title} {!!mentors?.length && `: ${mentors?.length}`}
            </h3>
            <div className="participants">
                {mentors?.map(mentor => (
                    <ExpertMentorItem
                        key={mentor.profileId}
                        profileId={mentor.profileId}
                        teamNumber={mentor.teamNumber}
                    />
                ))}
                {!mentors?.length && <h5>{t('help.noBody', 'Nobody')}</h5>}
            </div>
        </SectionStyles>
    )
}

export default HelpRequestPanel

const LoadingMessage = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: ${props => props.theme.color.gray};
`

const SectionStyles = styled.div`
    border: 1px solid ${props => props.theme.color.sidebar.gray1};
    border-radius: 8px;
    h3,
    h5 {
        color: ${props => props.theme.color.gray};
        border-bottom: 1px solid ${props => props.theme.color.sidebar.gray1};
        font-size: 12px;
        font-weight: bold;
        padding: 15px;
        margin: 0 0 15px 0;
        display: inline-block;
        width: 100%;
        .section-icon {
            margin-right: 8px;
        }
    }
    .participants {
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding-bottom: 15px;
    }
`

const HelpRequestPanelStyled = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
    .top {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow-y: scroll;
        gap: 10px;
        &::-webkit-scrollbar {
            width: 0;
            background: transparent;
        }
    }
`
